import React from 'react'
import { Portal, Content, type PopoverContentProps } from '@radix-ui/react-popover'
import { Box, SxStyleProp } from 'rebass/styled-components'

// Child "smart select" elements within dropdown content are styled via the below style object
// This allows targeting of `cmdk` elements, which don't support the `sx` prop
import { dropdownContentStyles } from './styles'
import theme from '../../theme'

export interface DropdownContentProps extends PopoverContentProps {
  sx?: SxStyleProp
}

export const DropdownContent = React.forwardRef<HTMLDivElement, DropdownContentProps>(
  ({ children, sx = {}, ...props }, ref) => (
    <Portal>
      <Content sideOffset={10} align="start" ref={ref} style={{ zIndex: theme.zIndices.popover }} {...props}>
        <Box
          data-name="DropdownContent"
          sx={{
            ...dropdownContentStyles,
            ...sx
          }}
        >
          {children}
        </Box>
      </Content>
    </Portal>
  )
)
DropdownContent.displayName = 'DropdownContent'
